import { AutogenLayoutProspectTypeList } from "./autogen/AutogenLayoutProspectTypeList";

export class ProspectTypeList extends AutogenLayoutProspectTypeList {
    onLoad(): void | Promise<void> {
        this.tableTypes.addButtonCaption = "Add Prospect Type";
    }
}